/*
This is the component to show the criteria definition summary. Typically usage would be to show the agent
all of the criteria and  in one page and provide edit/delete actions.
*/

import {Card, CardContent, Grid, Typography, Box} from "@material-ui/core";
import React from "react";

export default function AgentMatchCriteriaView(props) {
    const criteria = props.data;
    const zipcodes = criteria.zipCodes.join(', ')
    const counties = criteria.counties.join(', ')
    const propertyTypes = criteria.propertyTypes.join(', ')
    const propertyValue = `min of ${criteria.propertyValue.min} and max of ${criteria.propertyValue.max}`
    return (
        <>
            <Card variant={"elevation"}>
                <CardContent sx={{display: 'flex', flexDirection: 'row'}}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Box mb={2}>
                                <Typography variant={"h6"} component={"div"}>
                                    {criteria.name}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            {zipcodes && <Grid container direction={"row"} spacing={1}>
                                <Grid item xs={5}><strong>Zipcodes:</strong></Grid>
                                <Grid item xs={7}>{zipcodes}</Grid>
                            </Grid>}
                            {counties && <Grid container direction={"row"} spacing={1}>
                                <Grid item xs={5}><strong>Counties:</strong></Grid>
                                <Grid item xs={7}>{counties}</Grid>
                            </Grid>}
                            {propertyTypes && <Grid container direction={"row"} spacing={1}>
                                <Grid item xs={5}><strong>Property Types:</strong></Grid>
                                <Grid item xs={7}>{propertyTypes}</Grid>
                            </Grid>}
                            {propertyValue && <Grid container direction={"row"} spacing={1}>
                                <Grid item xs={5}><strong>Property Value:</strong></Grid>
                                <Grid item xs={7}>{propertyValue}</Grid>
                            </Grid>}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
}